import { useNavigate } from "react-router-dom";
import NotificationsView from "./view";

export default function Notifications() {
  const navigate = useNavigate();

  const goBack = () => navigate(-1);

  return <NotificationsView goBack={goBack} />;
}
